import React from 'react';
import classnames from 'classnames';
import {cssClasses} from './constants';

export interface TitleProps<T> extends React.HTMLProps<T> {
  className?: string;
  tag?: string;
}

const Title: <T extends HTMLElement = HTMLSpanElement>(
  props: TitleProps<T>
) => React.ReactElement<T> = ({
  children,
  className,
  tag: Tag = 'span',
  ...otherProps
}) => (
  // @ts-ignore  https://github.com/Microsoft/TypeScript/issues/28892
  <Tag className={classnames(className, cssClasses.TITLE)} {...otherProps}>
    {children}
  </Tag>
);

export default Title;
